/* eslint-disable @nx/enforce-module-boundaries */
import { Component, ElementRef, Inject, ViewChild, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { LoaderIndicatorDirective, LoaderService, NotificationService } from '@t-llevo/common-ui';
import { UserService } from '../../../api/services/user.service';
import { MatButtonModule } from '@angular/material/button';
import { toSignal } from '@angular/core/rxjs-interop';
import { DialogHeaderComponent } from 'admin-drivers/src/app/common/dialog/components/dialog-header/dialog-header.component';
import { finalize } from 'rxjs';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { emailValidators } from 'admin-drivers/src/app/common/validators';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { User } from 'admin-drivers/src/app/common/models/User';

@Component({
  selector: 't-llevo-user-edit',
  standalone: true,
  imports: [
    MatDialogModule,
    LoaderIndicatorDirective,
    MatButtonModule,
    DialogHeaderComponent,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  templateUrl: './user-edit.component.html',
  providers: [
    UserService,
    LoaderService
  ],
  styles: `
  @import '../../../utils/styles/baseDialog.scss';
  @import '../../../utils/styles/formGroup.scss';
  `,
})
export class UserEditComponent {
  private userSrv = inject(UserService)
  private loaderSrv = inject(LoaderService)
  private notifSrv = inject(NotificationService)

  @ViewChild('firstInput') elementRef!: ElementRef<HTMLInputElement>

  loading = toSignal(this.loaderSrv.loaderState$)

  frm = this._fb.group({
    phone: ['', [Validators.required, Validators.pattern(/[0-9]{8}/)]],
    email: ['', emailValidators],
    firstname: ['', [Validators.required]],
    lastname: ['', [Validators.required]],
  })

  constructor(
    public dialogRef: MatDialogRef<UserEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User,
    private _fb: NonNullableFormBuilder
  ){
    this.dialogRef.afterOpened().subscribe(()=>{
      setTimeout(() => {
        this.elementRef.nativeElement.focus()
      }, 100);

      this.assignData()
    })
  }

  private assignData(){
    this.frm.controls['firstname'].setValue( this.data.firstname)
    this.frm.controls['lastname'].setValue( this.data.lastname)
    this.frm.controls['email'].setValue( this.data.email)
    this.frm.controls['phone'].setValue( this.data.phone)
  }

  onSubmit() {
    this.loaderSrv.show()

    this.userSrv.updateUserById(this.frm.getRawValue(), this.data.id)
    .pipe(
      finalize(() => this.loaderSrv.hide())
    )
    .subscribe({
      next: () => {
        this.notifSrv.dispatch('Usuario editado', 'success')
        this.dialogRef.close(true)
      },
      error: (err: HttpErrorResponse) => {
        this.notifSrv.dispatch(err.error.message, 'error')
      }
    })
  }

  get phone() {
    return this.frm.controls['phone'];
  }

  get email() {
    return this.frm.controls['email'];
  }

  get firstname() {
    return this.frm.controls['firstname']
  }

  get lastname() {
    return this.frm.controls['lastname']
  }
}
